const styles = theme => ({
  tooltip: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    color: 'inherit',
    fontSize: theme.typography.pxToRem(12),
    boxShadow: theme.shadows[1],
    borderRadius: 0,
    border: `1px solid ${theme.palette.grey[300]}`,
    ...theme.typography.body2
  },
  arrow: {
    '&::before': {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.grey[300]}`
    }
  },
  tooltipContent: {
    display: 'flex',
    alignItems: 'center'
  },
  infoIcon: {}
});

export default styles;
